"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useNavMarker = _interopRequireDefault(require("./useNavMarker"));

var NavMarkerImpl = function NavMarkerImpl(_ref) {
  var name = _ref.name;
  (0, _useNavMarker.default)(name);
  return null;
};

if (process.env.NODE_ENV !== 'production') {
  NavMarkerImpl.propTypes = {
    name: _propTypes.default.string.isRequired
  };
}

var NavMarker = function NavMarker(_ref2) {
  var children = _ref2.children,
      name = _ref2.name,
      _ref2$active = _ref2.active,
      active = _ref2$active === void 0 ? true : _ref2$active;
  return _react.default.createElement(_react.default.Fragment, null, children, active && _react.default.createElement(NavMarkerImpl, {
    name: name
  }));
};

if (process.env.NODE_ENV !== 'production') {
  NavMarker.propTypes = {
    name: _propTypes.default.string.isRequired,
    children: _propTypes.default.node,
    active: _propTypes.default.bool
  };
}

var _default = NavMarker;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5051/js/NavMarker.js
// module id = 547
// module chunks = 5 6